// extracted by mini-css-extract-plugin
module.exports = {"houseContainer":"House_houseContainer__2R8VZ","stickyContainer":"House_stickyContainer__qEJPA"};